import ShareModal from '@/components/post-actions/ShareModal'
import DownloadBtn from '@/components/post-actions/DownloadBtn'
import PrintBtn from '@/components/post-actions/PrintBtn'
import { BookmarkAction, BookmarkButtonDefault } from '@/components/post-actions/BookmarkAction'

type PostActionsProps = {
  actions: {
    share?: boolean
    download?: boolean
    print?: boolean
    bookmark?: boolean
  }
  postId?: string | number
}

export default function PostActions({ actions, postId = null }: PostActionsProps) {
  const { share = true, download = true, print = true, bookmark = true } = actions

  const btnClass =
    'inline-flex h-40 w-40 items-center justify-center rounded-sm text-fg-title theme--gradient-dark:hover:text-black hover:bg-theme-accent transition-colors duration-200 ease-in-out'

  if (!share && !download && !print && !bookmark) {
    return null
  }

  return (
    <div className="--hide-from-pdf flex items-center gap-xxs">
      {share ? <ShareModal btnClass={btnClass} /> : null}
      {download ? <DownloadBtn btnClass={btnClass} /> : null}
      {print ? <PrintBtn btnClass={btnClass} /> : null}

      {bookmark ? (
        <BookmarkAction postId={postId}>
          <BookmarkButtonDefault />
        </BookmarkAction>
      ) : null}
    </div>
  )
}
